import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  geOrdersReportList,
  gevOrdersList,
} from "../../../../redux/actions/godsEyeViewActions";
import LoadingSpinner from "../../../../components/utilites/loaderSpinningContainer";
import searcher from "../../../../assets/icons/searchInput.svg";
import UpArrow from "../../../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../../../assets/icons/filterArrowDown.svg";
import moment from "moment";
import OrderTableData from "./orderTableData";
import exportFromJSON from "export-from-json";
import ErrorPopup from "../../../../components/popups/ErrorPopup";
import NumberPagination from "../../../../components/Pagination/number-pagination";

const OrdersList = ({}) => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const orderDateRef = useRef(null);
  const orderValueRef = useRef(null);
  const orderStatusRef = useRef(null);
  const invoiceStatusRef = useRef(null);
  const location = useLocation();
  const pathVerify = location?.pathname;
  const parts = pathVerify.split("/");
  const pathType = parts[parts.length - 3];
  const vendor_id = params?.id.split("&")?.[0];
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  const filterStoredData = {
    invStatus: queryParamsData.get("invStatus") ?? "",
    order_date_from: queryParamsData.get("order_date_from") ?? "",
    order_date_to: queryParamsData.get("order_date_to") ?? "",
    order_value_from: queryParamsData.get("order_value_from") ?? "",
    order_value_to: queryParamsData.get("order_value_to") ?? "",
    status: queryParamsData.get("status") ?? "",
  };
  const orderStatusArray = filterStoredData?.status
    ? filterStoredData?.status?.split(",")
    : [];
  const [page, setPage] = useState(page_no ?? 1);
  const [invStatus, setInvStatus] = useState(filterStoredData?.invStatus ?? "");
  const [order_date_from, setOrder_date_from] = useState(
    filterStoredData?.order_date_from ?? ""
  );
  const [order_date_to, setOrder_date_to] = useState(
    filterStoredData?.order_date_to ?? ""
  );
  const [order_value_from, setOrder_value_from] = useState(
    filterStoredData?.order_value_from ?? ""
  );
  const [order_value_to, setOrder_value_to] = useState(
    filterStoredData?.order_value_to ?? ""
  );
  const [status, setStatus] = useState(orderStatusArray ?? []);
  const [ordersData, setordersData] = useState(null);
  const [openOrder, setOpenOrder] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [openInvStatus, setOpenInvStatus] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [filteredStatusOptions, setFilteredStatusOptions] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (filterStoredData?.invStatus) {
      setInvStatus(filterStoredData?.invStatus ?? "");
    } else {
      setInvStatus("");
    }
    if (filterStoredData?.order_date_from) {
      setOrder_date_from(filterStoredData?.order_date_from ?? "");
    } else {
      setOrder_date_from("");
    }
    if (filterStoredData?.order_date_to) {
      setOrder_date_to(filterStoredData?.order_date_to ?? "");
    } else {
      setOrder_date_to("");
    }
    if (filterStoredData?.order_value_from) {
      setOrder_value_from(filterStoredData?.order_value_from);
    } else {
      setOrder_value_from("");
    }
    if (filterStoredData?.order_value_to) {
      setOrder_value_to(filterStoredData?.order_value_to ?? "");
    } else {
      setOrder_value_to("");
    }
  }, [
    filterStoredData?.invStatus,
    filterStoredData?.order_date_from,
    filterStoredData?.order_date_to,
    filterStoredData?.order_value_from,
    filterStoredData?.order_value_to,
  ]);

  useEffect(() => {
    if (filterStoredData?.status) {
      setStatus(filterStoredData?.status?.split(","));
    } else if (filterStoredData?.status === undefined) {
      setStatus([]);
    } else {
      setStatus([]);
    }
  }, [filterStoredData?.status]);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  const OrderValueSubmit = () => {
    setOpenOrder(false);
    navigate(
      `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
        search ? `&search=${search}` : ""
      }${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_date_from
          ? `&order_date_from=${filterStoredData?.order_date_from}`
          : ""
      }${
        filterStoredData?.order_date_to
          ? `&order_date_to=${filterStoredData?.order_date_to}`
          : ""
      }${
        filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""
      }&order_value_from=${
        order_value_from ?? ""
      }&order_value_to=${order_value_to}`
    );
  };

  const OrderDateSubmit = () => {
    setOpenDate(false);
    navigate(
      `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
        search ? `&search=${search}` : ""
      }${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_value_from
          ? `&order_value_from=${filterStoredData?.order_value_from}`
          : ""
      }${
        filterStoredData?.order_value_to
          ? `&order_value_to=${filterStoredData?.order_value_to}`
          : ""
      }${
        filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""
      }&order_date_from=${order_date_from ?? ""}&order_date_to=${order_date_to}`
    );
  };

  const applyStatusFilter = () => {
    navigate(
      `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
        search ? `&search=${search}` : ""
      }${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_date_from
          ? `&order_date_from=${filterStoredData?.order_date_from}`
          : ""
      }${
        filterStoredData?.order_date_to
          ? `&order_date_to=${filterStoredData?.order_date_to}`
          : ""
      }${
        filterStoredData?.order_value_from
          ? `&order_value_from=${filterStoredData?.order_value_from}`
          : ""
      }${
        filterStoredData?.order_value_to
          ? `&order_value_to=${filterStoredData?.order_value_to}`
          : ""
      }&status=${status ?? []}`
    );
  };

  useEffect(() => {
    setLoading(true);
    let order_status = status?.join(",");
    let invoice_verified = invStatus;
    dispatch(
      gevOrdersList(
        {
          vendor_id,
          order_date_from: filterStoredData?.order_date_from,
          order_date_to: filterStoredData?.order_date_to,
          order_value_from: filterStoredData.order_value_from,
          order_value_to: filterStoredData.order_value_to,
          search,
          page,
          order_status,
          invoice_verified,
        },
        onSuccess,
        onError
      )
    );
  }, [
    search,
    page,
    invStatus,
    filterStoredData.order_value_from,
    filterStoredData.order_value_to,
    filterStoredData.order_date_from,
    filterStoredData.order_date_to,
    filterStoredData?.status,
  ]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (filterStoredData?.invStatus)
    queryParams.push(`invStatus=${filterStoredData?.invStatus}`);
  if (filterStoredData?.order_value_from)
    queryParams.push(`order_value_from=${filterStoredData?.order_value_from}`);
  if (filterStoredData?.order_value_to)
    queryParams.push(`order_value_to=${filterStoredData?.order_value_to}`);
  if (filterStoredData?.order_date_from)
    queryParams.push(`order_date_from=${filterStoredData?.order_date_from}`);
  if (filterStoredData?.order_date_to)
    queryParams.push(`order_date_to=${filterStoredData?.order_date_to}`);
  if (filterStoredData?.status)
    queryParams.push(`status=${filterStoredData?.status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data);
    setordersData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const orderValueClear = () => {
    setOrder_value_from(null);
    setOrder_value_to(null);
    navigate(
      `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
        search ? `&search=${search}` : ""
      }${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_date_from
          ? `&order_date_from=${filterStoredData?.order_date_from}`
          : ""
      }${
        filterStoredData?.order_date_to
          ? `&order_date_to=${filterStoredData?.order_date_to}`
          : ""
      }${filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""}`
    );
    setOpenOrder(false);
  };
  const orderDateClear = () => {
    setOrder_date_from(null);
    setOrder_date_to(null);
    navigate(
      `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
        search ? `&search=${search}` : ""
      }${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_value_from
          ? `&order_value_from=${filterStoredData?.order_value_from}`
          : ""
      }${
        filterStoredData?.order_value_to
          ? `&order_value_to=${filterStoredData?.order_value_to}`
          : ""
      }${filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""}`
    );
    setOpenDate(false);
  };

  const fileName = "report"; // CSV
  const exportType = exportFromJSON.types.csv; // CSV

  const exportTableCsv = () => {
    console.log("clicked");
    dispatch(geOrdersReportList(vendor_id, onReprtSuccess, onReprtError));
  };
  const closeSuccessPopup = () => {
    setShowErrorPopup(false);
  };

  const onReprtSuccess = (data) => {
    console.log(data);
    if (data?.data?.data?.length > 0) {
      const tableData = [];
      data?.data?.data?.map((data, index) => {
        tableData.push({
          "sl no": index + 1,
          "Order ID": data?.order_id ? data?.order_id : "--",
          "Customer Name":
            data?.customer_type === "doctor"
              ? data?.doctor?.name
              : data?.pharmacy_type == "dispensing" ||
                data?.customer_type !== "doctor"
              ? data?.pharmacy?.pharmacy_name
              : data?.pharmacy_type == "dispensing"
              ? "Dispensing"
              : data?.pharmacy_type == "self"
              ? data?.doctorSelfPharmacy?.pharmacy_name
              : data?.doctorAttachPharmacy?.pharmacy?.pharmacy_name,
          "Order Date": data?.createdAt
            ? moment(data?.createdAt).format("DD MMM YYYY, HH:mm A")
            : "--",
          "Order Value": data?.total
            ? `₹ ${parseFloat(data?.total).toFixed(2)}`
            : "--",
          "Order Status": data?.status ? data?.status : "--",
          "Invoice Status": data?.invoice_status ? data?.invoice_status : "--",
          "PO Status": data?.po_status ? data?.po_status : "--",
          "Reason For Rejection": data?.rejectionReason?.title
            ? data?.rejectionReason?.title
            : "--",
          "Rejected By":
            (data?.rejected_by_user_type == "distributor" &&
              data?.rejectOrderbyDistributor?.firm_name) ||
            (data?.rejected_by_user_type == "field_force_user" &&
              data?.rejectOrderbyFieldForce?.firm_name) ||
            (data?.rejected_by_user_type == "vendor" &&
              data?.rejectOrderbyVendor?.firm_name) ||
            (data?.rejected_by_user_type == "doctor" &&
              data?.rejectOrderbyDoctor?.firm_name) ||
            "--",
        });
      });
      exportFromJSON({ data: tableData, fileName, exportType });
    } else {
      setShowErrorPopup(true);
      setShowErrorMsg("No data Found");
      setTimeout(closeSuccessPopup, 2000);
    }
  };

  const onReprtError = (err) => {
    setShowErrorPopup(true);
    setShowErrorMsg("Something went wrong");
    setTimeout(closeSuccessPopup, 2000);
  };

  const handleStatusInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchValue(e.target.value);
    const filtered = orderStatusOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue)
    );
    setFilteredStatusOptions(filtered);
  };

  const handleClickOrderDateOutside = (event) => {
    if (orderDateRef.current && !orderDateRef.current.contains(event.target)) {
      setOpenDate(false);
    }
  };
  const handleClickOrderValueOutside = (event) => {
    if (
      orderValueRef.current &&
      !orderValueRef.current.contains(event.target)
    ) {
      setOpenOrder(false);
    }
  };
  const handleClickOutside = (event) => {
    if (
      orderStatusRef.current &&
      !orderStatusRef.current.contains(event.target)
    ) {
      setOpenStatus(false);
    }
  };
  const handleClickInvoiceOutside = (event) => {
    if (
      invoiceStatusRef.current &&
      !invoiceStatusRef.current.contains(event.target)
    ) {
      setOpenInvStatus(false);
    }
  };

  useEffect(() => {
    if (openDate) {
      document.addEventListener("click", handleClickOrderDateOutside);
    } else {
      document.removeEventListener("click", handleClickOrderDateOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOrderDateOutside);
    };
  }, [openDate]);

  useEffect(() => {
    if (openOrder) {
      document.addEventListener("click", handleClickOrderValueOutside);
    } else {
      document.removeEventListener("click", handleClickOrderValueOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOrderValueOutside);
    };
  }, [openOrder]);

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  useEffect(() => {
    if (openInvStatus) {
      document.addEventListener("click", handleClickInvoiceOutside);
    } else {
      document.removeEventListener("click", handleClickInvoiceOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickInvoiceOutside);
    };
  }, [openInvStatus]);

  return (
    <div className="mx-5 px- my-3 mt-4">
      <div className="d-flex justify-content-between">
        <div className="search-box w-50 d-flex align-items-center p-2 m-1 mb-2">
          <img className="styled-SVG" src={searcher} color={""} />
          <input
            value={search}
            className="search-input fs_14 fw_400 text-dark px-2"
            type="text"
            placeholder="Search orders here by order ID..."
            onChange={(e) => {
              navigate(
                `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
                  e.target.value ? `&search=${e.target.value}` : ""
                }${
                  filterStoredData?.invStatus
                    ? `&invStatus=${filterStoredData?.invStatus}`
                    : ""
                }${
                  filterStoredData?.order_date_from
                    ? `&order_date_from=${filterStoredData?.order_date_from}`
                    : ""
                }${
                  filterStoredData?.order_date_to
                    ? `&order_date_to=${filterStoredData?.order_date_to}`
                    : ""
                }${
                  filterStoredData?.order_value_from
                    ? `&order_value_from=${filterStoredData?.order_value_from}`
                    : ""
                }${
                  filterStoredData?.order_value_to
                    ? `&order_value_to=${filterStoredData?.order_value_to}`
                    : ""
                }${
                  filterStoredData?.status
                    ? `&status=${filterStoredData?.status}`
                    : ""
                }`
              );
            }}
          />
        </div>
        <div>
          <button
            onClick={() =>
              navigate(
                `/manufacturer/${pathType}/view/${vendor_id}&orders&list`
              )
            }
            className="py-2 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
          >
            Clear Filters
          </button>
          <button
            className="verify-btn text-uppercase px-2 py-2 my-2 fs_12"
            type="button"
            onClick={() => exportTableCsv()}
          >
            download
          </button>
        </div>
      </div>
      <div
        className="manufacturer-product-table-container"
        style={{ height: "33.5rem", maxWidth: "100%" }}
      >
        <div style={{ height: "32rem" }}>
          <table className="main-table  text-nowrap">
            <thead
              style={{ position: "sticky", top: 0, zIndex: 55 }}
              className="bg-white"
            >
              <tr className="table-rows color_747f9e">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  Order ID
                </th>
                <th className="table-heads " width={"10%"}>
                  Customer name
                </th>
                <th
                  ref={orderDateRef}
                  className="table-heads text-nowrap "
                  width={"12%"}
                >
                  <span
                    onClick={() => {
                      setOpenDate(!openDate);
                      setOpenOrder(false);
                    }}
                    className="cursor_pointer"
                  >
                    <span
                      className={
                        filterStoredData?.order_date_from &&
                        filterStoredData?.order_date_to
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Order Date
                    </span>

                    {openDate ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" />
                    )}
                  </span>
                  {openDate ? (
                    <div className="position-relative">
                      <div className="position-absolute order-container">
                        <div className="d-flex my-3">
                          <div className="mx-3">
                            <label className="fn_Nunito color_262c3d ">
                              From
                            </label>
                            <div className="d-flex mt-1 ">
                              <div className="d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <input
                                  type="date"
                                  className="amount_input  py-1  ms-1"
                                  placeholder="Select Date"
                                  value={order_date_from && order_date_from}
                                  onfocus="(this.type = 'date')"
                                  id="date"
                                  onChange={(e) =>
                                    setOrder_date_from(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="me-3">
                            <label className="fn_Nunito color_262c3d ">
                              To
                            </label>
                            <div className=" d-flex mt-1">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <input
                                  type="date"
                                  className="  amount_input  py-1  ms-1"
                                  placeholder=" Selct Date"
                                  value={order_date_to}
                                  onChange={(e) =>
                                    setOrder_date_to(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <div className="d-flex justify-content-end mx-3 gap-3">
                            <button
                              className="filter-clear-btn px-3 py-1 fs_14"
                              onClick={orderDateClear}
                            >
                              clear
                            </button>
                            <button
                              className="filter-btn px-2 py-1 fs_14"
                              type="button"
                              onClick={OrderDateSubmit}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th
                  ref={orderValueRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    onClick={() => {
                      setOpenOrder(!openOrder);
                      setOpenDate(false);
                    }}
                    className="cursor_pointer"
                  >
                    <span
                      className={
                        filterStoredData?.order_value_from &&
                        filterStoredData?.order_value_to
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Order Value
                    </span>
                    {openOrder ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>

                  {openOrder ? (
                    <div className="position-relative">
                      <div className="position-absolute order-container">
                        <div className=" d-flex my-3">
                          <div className="mx-3">
                            <label className="fn_Nunito color_262c3d ">
                              From
                            </label>
                            <div className=" d-flex mt-1 ">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <span className="fn_Nunito fs_14 fw_700 Medium_Purple ">
                                  ₹.
                                </span>
                                <input
                                  type="number"
                                  className="  amount_input  py-1  ms-1"
                                  placeholder="Enter amount"
                                  value={order_value_from}
                                  onChange={(e) =>
                                    setOrder_value_from(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="me-3">
                            <label className="fn_Nunito color_262c3d ">
                              To
                            </label>
                            <div className=" d-flex mt-1">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <span className="fn_Nunito fs_14 fw_700 Medium_Purple ">
                                  ₹.
                                </span>
                                <input
                                  type="number"
                                  className="  amount_input  py-1  ms-1"
                                  placeholder="Enter amount"
                                  value={order_value_to && order_value_to}
                                  onChange={(e) =>
                                    setOrder_value_to(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <div className="d-flex justify-content-end mx-3 gap-3">
                            <button
                              className="filter-clear-btn px-3 py-1 fs_14"
                              onClick={orderValueClear}
                            >
                              clear
                            </button>
                            <button
                              className="filter-btn px-2 py-1 fs_14"
                              type="button"
                              onClick={OrderValueSubmit}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads text-nowrap" width={"10%"}>
                  Distributed by
                </th>
                <th
                  ref={orderStatusRef}
                  className="table-heads text-nowrap"
                  width={"12%"}
                >
                  <span
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    <span
                      className={
                        filterStoredData?.status?.length > 0
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Order Status
                    </span>

                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className="mx-1" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className="position-relative">
                      <div className="city-main-container">
                        <div className="city-filter-form">
                          <div className="mx-2 my-1 pt-1">
                            <input
                              value={searchValue}
                              type={"text"}
                              placeholder={"search"}
                              className="filter-input w-100 py-1 px-2"
                              onChange={handleStatusInputChange}
                            />
                          </div>
                          <div
                            className="row"
                            style={{ height: "6.4rem", overflowY: "scroll" }}
                          >
                            {(filteredStatusOptions.length > 0
                              ? filteredStatusOptions
                              : orderStatusOptions
                            ).map((item, index) => (
                              <div
                                className="col-5 d-flex align-items-center ms-4"
                                key={index}
                              >
                                <div>
                                  <span className="fs_14 my-1">
                                    <input
                                      type="checkbox"
                                      name="status"
                                      checked={status.includes(item.value)}
                                      className="ffCheck"
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setStatus((prev) => [
                                            ...prev,
                                            item.value,
                                          ]);
                                        } else {
                                          setStatus((prev) =>
                                            prev.filter(
                                              (ex) => ex !== item.value
                                            )
                                          );
                                        }
                                      }}
                                    />
                                  </span>
                                </div>
                                <div className="mt-2 mx-2">
                                  <span className="color_747f9e fs_14">
                                    {item.label}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mx-3 gap-3">
                          <button
                            type="button"
                            className="filter-clear-btn px-3 py-1 fs_14"
                            onClick={() => {
                              setStatus([]);
                              setOpenStatus(false);
                              setFilteredStatusOptions([]);
                              navigate(
                                `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
                                  search ? `&search=${search}` : ""
                                }${
                                  filterStoredData?.invStatus
                                    ? `&invStatus=${filterStoredData?.invStatus}`
                                    : ""
                                }${
                                  filterStoredData?.order_date_from
                                    ? `&order_date_from=${filterStoredData?.order_date_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_date_to
                                    ? `&order_date_to=${filterStoredData?.order_date_to}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_from
                                    ? `&order_value_from=${filterStoredData?.order_value_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_to
                                    ? `&order_value_to=${filterStoredData?.order_value_to}`
                                    : ""
                                }`
                              );
                            }}
                          >
                            clear
                          </button>
                          <button
                            className="filter-btn px-2 py-1 fs_14"
                            onClick={() => {
                              setOpenStatus(!openStatus);
                              applyStatusFilter();
                            }}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </th>

                <th
                  ref={invoiceStatusRef}
                  className="table-heads text-nowrap"
                  width={"10%"}
                >
                  <span
                    onClick={() => setOpenInvStatus(!openInvStatus)}
                    className={
                      openInvStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    <span
                      className={
                        filterStoredData?.invStatus
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Invoice Status
                    </span>
                    {openInvStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>
                  {openInvStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="pending"
                            name="pending"
                            value={"pending"}
                            checked={invStatus == "pending"}
                            onClick={(e) => {
                              setOpenInvStatus(!openInvStatus);
                              setInvStatus(e.target.value);
                              navigate(
                                `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
                                  search ? `&search=${search}` : ""
                                }${
                                  filterStoredData?.order_date_from
                                    ? `&order_date_from=${filterStoredData?.order_date_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_date_to
                                    ? `&order_date_to=${filterStoredData?.order_date_to}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_from
                                    ? `&order_value_from=${filterStoredData?.order_value_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_to
                                    ? `&order_value_to=${filterStoredData?.order_value_to}`
                                    : ""
                                }${
                                  filterStoredData?.status
                                    ? `&status=${filterStoredData?.status}`
                                    : ""
                                }&invStatus=pending`
                              );
                            }}
                          />
                          <label
                            htmlFor="pending"
                            className={
                              invStatus === "pending"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Pending
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="verified"
                            name="verified"
                            value={"verified"}
                            checked={invStatus === "verified"}
                            onClick={(e) => {
                              setOpenInvStatus(!openInvStatus);
                              setInvStatus(e.target.value);
                              navigate(
                                `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
                                  search ? `&search=${search}` : ""
                                }${
                                  filterStoredData?.order_date_from
                                    ? `&order_date_from=${filterStoredData?.order_date_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_date_to
                                    ? `&order_date_to=${filterStoredData?.order_date_to}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_from
                                    ? `&order_value_from=${filterStoredData?.order_value_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_to
                                    ? `&order_value_to=${filterStoredData?.order_value_to}`
                                    : ""
                                }${
                                  filterStoredData?.status
                                    ? `&status=${filterStoredData?.status}`
                                    : ""
                                }&invStatus=verified`
                              );
                            }}
                          />
                          <label
                            htmlFor="verified"
                            className={
                              invStatus === "verified"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Verified
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setInvStatus(null);
                            setOpenInvStatus(!openInvStatus);
                            navigate(
                              `/manufacturer/${pathType}/view/${vendor_id}&orders&list?page=1${
                                search ? `&search=${search}` : ""
                              }${
                                filterStoredData?.order_date_from
                                  ? `&order_date_from=${filterStoredData?.order_date_from}`
                                  : ""
                              }${
                                filterStoredData?.order_date_to
                                  ? `&order_date_to=${filterStoredData?.order_date_to}`
                                  : ""
                              }${
                                filterStoredData?.order_value_from
                                  ? `&order_value_from=${filterStoredData?.order_value_from}`
                                  : ""
                              }${
                                filterStoredData?.order_value_to
                                  ? `&order_value_to=${filterStoredData?.order_value_to}`
                                  : ""
                              }${
                                filterStoredData?.status
                                  ? `&status=${filterStoredData?.status}`
                                  : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads text-nowrap" width={"8%"}>
                  PO Status
                </th>
                <th className="table-heads text-nowrap" width={"15%"}>
                  Reason For Rejection
                </th>
                <th className="table-heads text-nowrap" width={"10%"}>
                  Rejected By
                </th>
                <th className="table-heads text-nowrap" width={"19%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="mt-3" style={{ position: "relative" }}>
              {loading == true ? (
                <div className="gev-spinner-container">
                  <LoadingSpinner />
                </div>
              ) : (
                <>
                  {ordersData?.orders?.length > 0 ? (
                    ordersData?.orders?.map((data, index) => (
                      <React.Fragment key={index}>
                        <OrderTableData
                          data={data}
                          index={index}
                          currentPage={ordersData?.pagination?.currentPage}
                        />
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="1"
                        className="text-center no-data-container fs_16"
                      >
                        <span>~ No Data Found ~</span>
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {ordersData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={ordersData?.pagination?.currentPage}
          totalPages={ordersData?.pagination?.totalPages}
          path={`/manufacturer/${pathType}/view/${vendor_id}&orders&list`}
          filters={`${queryString}`}
        />
      )}

      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </div>
  );
};

export default OrdersList;

export const orderStatusOptions = [
  { value: "acknowledged", label: "Acknowledged", color: "ack_status" },
  {
    value: "partially_acknowledged",
    label: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { value: "fully_invoiced", label: "Fully Invoiced", color: "text_green" },
  {
    value: "partially_invoiced",
    label: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { value: "pending", label: "Approval Pending", color: "Medium_Purple" },
  { value: "expired", label: "Expired", color: "text-danger" },
  { value: "cancelled", label: "Cancelled", color: "text-danger" },
  { value: "approval_failed", label: "Approval Failed", color: "text-danger" },
  { value: "approved", label: "Approved", color: "color_2ad3e7" },
  { value: "rejected", label: "Rejected", color: "text-danger" },
  { value: "hold", label: "Under Process", color: "text-warning" },
];
